var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1026 4.5H5.852C3.44845 4.5 1.5 6.46633 1.5 8.89193L1.5 15.0721C1.5 17.4977 3.44845 19.464 5.852 19.464H18.1026C20.5061 19.464 22.4546 17.4977 22.4546 15.0721V8.89193C22.4546 6.46633 20.5061 4.5 18.1026 4.5ZM15.1594 12.2827L9.42936 15.0406C9.27668 15.1141 9.10032 15.0018 9.10032 14.8311V9.14284C9.10032 8.96973 9.28132 8.85752 9.43432 8.93578L15.1643 11.8661C15.3347 11.9532 15.3317 12.1998 15.1594 12.2827Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcYoutube);
export default __webpack_public_path__ + "static/media/ic_youtube.3d05ddce929eedc5f58569d684c794cc.svg";
export { ForwardRef as ReactComponent };